<template>
    <div class="crm-main-cont">
        <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="待审核">
                <div class="search-box" >
                    <a-form :form="formSearch" layout="inline">
                        <a-form-item label="名称">
                            <a-input v-decorator="['name']" />
                        </a-form-item>
                    </a-form>
                </div>
                <div class="btns-group">
                    <a-button type="primary" @click="handleSearch()">
                        搜索
                    </a-button>
                    <a-button @click="reset()">
                        重置
                    </a-button>
                </div>

                <a-table
                        rowKey="id"
                        bordered
                        :dataSource="dataList1"
                        :pagination="pagination"
                        :columns="columns"
                >
                    <template slot="operation" slot-scope="text, record">
                        <a @click="handleApp(record.acount_id)">审核通过</a>
                    </template>
                    <template slot="create_time" slot-scope="text">
                        {{timestampToTime(text)}}
                    </template>
                    <template slot="state" slot-scope="text">
                        <p v-if="text == 0">审核中</p>
                        <p v-if="text == 1">已通过</p>
                    </template>
                </a-table>
            </a-tab-pane>

            <a-tab-pane key="2" tab="已审核记录">
                <div class="search-box" >
                    <a-form :form="formSearch2" layout="inline">
                        <a-form-item label="名称">
                            <a-input v-decorator="['name']" />
                        </a-form-item>
                    </a-form>
                </div>
                <div class="btns-group">
                    <a-button type="primary" @click="handleSearch2()">
                        搜索
                    </a-button>
                    <a-button @click="reset2()">
                        重置
                    </a-button>
                </div>

                <a-table
                        rowKey="id"
                        bordered
                        :dataSource="dataList2"
                        :pagination="pagination2"
                        :columns="columns2"
                >
                    <template slot="update_time" slot-scope="text, record">
                        {{timestampToTime(text)}}
                    </template>
                    <template slot="state" slot-scope="text, record">
                        <p v-if="text == 0">审核中</p>
                        <p v-if="text == 1">已通过</p>
                    </template>
                </a-table>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
    import {getApplications, Approved} from '@/api/yhgl/applications.js'
    import moment from 'moment'

    const columns = [
        {
            title: "申请人",
            dataIndex: "name",
            key: ""
        },
        {
            title: "审核状态",
            dataIndex: "state",
            key: "",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "申请时间",
            dataIndex: "create_time",
            key: "",
            scopedSlots: { customRender: "create_time" }
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: { customRender: "operation" }
        }
    ];
    const columns2 = [
        {
            title: "申请人",
            dataIndex: "name",
        },
        {
            title: "审核人",
            dataIndex: "sh_user",
        },
        {
            title: "审核状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "审核时间",
            dataIndex: "update_time",
            key: "",
            scopedSlots: { customRender: "update_time" }
        },
    ];

    export default {
        data() {
            return {
                formSearch: this.$form.createForm(this),
                formSearch2: this.$form.createForm(this),
                columns,
                columns2,
                name: "",
                name2: "",
                type: 0,
                dataList1: [],
                dataList2: [],
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 15,
                    onChange: page => {
                        this.pageChange(0, page);
                    },
                },
                pagination2: {
                    total: 0,
                    current: 1,
                    pageSize: 15,
                    onChange: page => {
                        this.pageChange2(1, page);
                    },
                },
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initList()
            })
        },

        methods: {
            callback(key) {
                if (key == 1){
                    this.type = 0;
                }if (key == 2){
                    this.type = 1;
                }
            },

            initList() {
                getApplications(this.name, "0").then(res => {
                    if (res.data.success === "TRUE") {
                        this.dataList1 = res.data.data.appList.list;
                        this.pagination.total = res.data.data.appList.total;
                        this.pagination.pageSize = res.data.data.appList.pageSize;
                        this.pagination.current = 1;
                    }
                });
                getApplications(this.name2, "1").then(res => {
                    if (res.data.success === "TRUE") {
                        this.dataList2 = res.data.data.appList.list;
                        this.pagination2.total = res.data.data.appList.total;
                        this.pagination2.pageSize = res.data.data.appList.pageSize;
                        this.pagination2.current = 1;
                    }
                });
            },

            getList(type, page) {
                if (type == 0){
                    getApplications(this.name, type, page).then(res => {
                        if (res.data.success === "TRUE") {
                            this.dataList1 = res.data.data.appList.list;
                        }
                    });
                }
                if (type == 1){
                    getApplications(this.name2, type, page).then(res => {
                        if (res.data.success === "TRUE") {
                            this.dataList2 = res.data.data.appList.list;
                        }
                    });
                }
            },

            handleSearch() {
                this.name = this.formSearch.getFieldsValue().name;
                this.initList();
            },

            reset() {
                this.name = "";
                this.formSearch.resetFields();
                this.initList();
            },

            handleSearch2() {
                this.name2 = this.formSearch2.getFieldsValue().name;
                console.log(this.name2);
                this.initList();
            },

            reset2() {
                this.name2 = "";
                this.formSearch2.resetFields();
                this.initList();
            },

            handleApp(id) {
                Approved(id).then( res => {
                    if (res.data.success == "TRUE"){
                        this.$message.success(res.data.message);
                        this.initList();
                    }else {
                        this.$message.info(res.data.message);
                    }
                }).catch(() => {
                    this.$message.error("服务器系统错误，请稍后重试！");
                });
            },

            pageChange(type, page) {
                this.pagination.current = page;
                this.getList(type, page);
            },

            pageChange2(type, page) {
                this.pagination2.current = page;
                this.getList(type, page);
            },


            timestampToTime (time) {
                return moment(time).format("YYYY-MM-DD HH:mm:ss");
            },
        },

    }
</script>

<style scoped lang="less">
    .ant-btn {
        font-size: 12px;
    }
    .ant-table-wrapper {
        font-size: 12px;
        margin-top: 20px;
    }
    .ant-table-row > td {
        font-size: 12px;
    }
    .spin-content {
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        padding: 30px;
    }
    .marRight {
        margin-left: 15px;
        margin-bottom: -20px;
    }
    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 169px;
        }
    }

    .btns-group button {
        margin-right: 10px;
        margin-top: 24px;
    }
</style>
